<template>
  <div class="mainAct d-flex" :class="open_close_panel?'sideBarCollapse': ''">
    <!-- <app-alerpop v-if="alertTab == 'alert'"></app-alerpop>
	<app-alert-modify v-if="alertModify == 'alert'"></app-alert-modify> -->
  <div class="act_web_dash calculateWidth">      
      <div class="d-flex splitTop">
        <div class="first-wishlist">
          <app-watchlist :loadChart="loadChart" :mn="mn" v-model="chartKeys" @clearAll="clearTrade"></app-watchlist>
        </div>
        <!--Main Chart -->
        <div class="split content split-horizontal second-wishlist" v-if="newsPopup">
          <app-newspopup />
        </div>
        <trading-view :loadChart="loadChart" :mn="mn" v-else-if="!showChart"></trading-view>
        <chart-iq :loadChart="loadChart" :mn="mn" @changeChart="changeChart" @placeTrade="placeTrade" v-else></chart-iq>
        <!--Main Chart Close-->
      </div>
      <appOrderHistory :currency_pair="loadChart" @modifyTrder="modifyTrade" @modifyOrder="modifyOrder" :modifyTradeID="(modifyTradeDetail || {}).TradeID " :modifyOrderID="(modifyOrderDetail || {}).OrderID"/>
    </div>
    <app-right-section @togglePanel="togglePanel" :currency_pair="loadChart" :modifyTradeDetail="modifyTradeDetail" :modifyOrderDetail="modifyOrderDetail" :placetradeDetail="placetradeDetail" @clearTrade="clearTrade" />
  </div>
</template>

<script>
// import app_alerpop from '../shared/alert-pop'
// import app_alert_modify from '../shared/modify-alert-pop'
// import chart_section from "./home-elements/chart-section";
import chart_iq from "../shared/chart-iq";
import trading_view from "../shared/trading-view";
import app_watchlist from "../shared/app-watchlist";
import order_history from "../shared/order/order-history";
import right_section from "./home-elements/right-sec";
import news_popup from "../shared/news-popup";
import { commonAllmixins } from '@/plugins/commonAll';
import { setTimeout } from "timers";
const product_type = process.env.product_type;
export default {
  mixins: [commonAllmixins],
  name: "home-view",
  data() {
    return {
      buySellType: "buy",
      page: "1",
      buySell: "",
      newsPopup: false,
      // filterOption: false,
      // alertModify: false,
      loadChart: "EURUSD"+product_type,
      mn: "EURUSD"+product_type,
      chartKeys: { key: "EURUSD"+product_type, mn: "EURUSD"+product_type },
      modifyTradeDetail : null,
      modifyOrderDetail : null,
      placetradeDetail:null,

      open_close_panel: false,
    };
  },
  methods:{
    togglePanel(){
      this.open_close_panel ^= true;
    },
    changeChart(Symbol){
      this.loadChart = Symbol;
      this.mn = Symbol;
    },
    clearTrade(){
      this.modifyTradeDetail = null
      this.modifyOrderDetail = null
      this.placetradeDetail = null
    },
    placeTrade(v){
      this.modifyOrderDetail = null;
      this.modifyTradeDetail = null;
      this.placetradeDetail = v;
    },
    modifyTrade(v){
      this.modifyOrderDetail = null;
      this.placetradeDetail = null;
      if(v && this.loadChart != v.Symbol){
        this.loadChart = v.Symbol;
        this.mn = v.Symbol;
        this.chartKeys.key = v.Symbol;
        this.chartKeys.mn = v.Symbol;
      }
      this.modifyTradeDetail = v
    },
    modifyOrder(v){
      if(this.modifyTradeDetail) this.modifyTradeDetail = null;
      if(this.placetradeDetail) this.placetradeDetail = null;
      if(v && this.loadChart != v.Symbol){
        this.loadChart = v.Symbol;
        this.mn = v.Symbol;
        this.chartKeys.key = v.Symbol;
        this.chartKeys.mn = v.Symbol;
      }
      this.modifyOrderDetail = v
    }
  },
  created(){
    if(localStorage.getItem("myChartLayout")){
      let ciq_data =  JSON.parse(localStorage.getItem("myChartLayout"))
      if(ciq_data.symbols && ciq_data.symbols[0] && ciq_data.symbols[0].symbol){
        this.chartKeys.key = ciq_data.symbols[0].symbol
        this.chartKeys.mn = ciq_data.symbols[0].symbol
        this.loadChart = ciq_data.symbols[0].symbol
        this.mn = ciq_data.symbols[0].symbol
      }
    }
  },
  watch: {
    chartKeys(value) {
      this.mn = value.mn;
      this.loadChart = value.key;
    },
  },
  components: {
    // appChartsecssion: chart_section,
    chartIq: chart_iq,
    tradingView: trading_view,
    appWatchlist: app_watchlist,
    appRightSection: right_section,
    appOrderHistory: order_history,
    appNewspopup: news_popup,
    // appAlerpop : app_alerpop,
    // appAlertModify:app_alert_modify,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/website/user/home.vue